import { _axios as request } from "../../plugins/axios";

const actions = {
    getAllPromotions(_,data){
        return new Promise((resolve, reject) => {
            request({
                url: '/promotionalactivities/getall',
                method: 'post',
                params: data,
            })
                .then((response) => {
                    resolve(response);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },
    editPromotion(_, data) {
        return new Promise((resolve, reject) => {
            request({
                url: '/promotionalactivities/modifyPromotionalActivity',
                method: 'post',
                data: data,
            })
                .then((response) => {
                    resolve(response);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },
    deletePromotion(_, data) {
        return new Promise((resolve, reject) => {
            request({
                url: '/promotionalactivities/delete',
                method: 'post',
                data: data
            })
                .then((response) => {
                    resolve(response);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },
    addPromotion(_, data) {
        return new Promise((resolve, reject) => {
            request({
                url: '/promotionalactivities/add',
                method: 'post',
                data: data
            })
                .then((response) => {
                    resolve(response);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },
}

export default {
    namespaced: true,
    actions,
};